module.exports = __webpack_public_path__ + "static/media/documents.93652b64.svg";